<template>
    <transition name="fade">
        <main id="machine-sheet-best-seller">
            <div class="wrapper" v-if="displayContent">
                <h2 class="main-title-container">
                    <span class="main-title">
                      {{ $t("choose_bestseller_version") }}
                        <span class="icon-colored-star star-1"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                        <span class="icon-colored-star star-2"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                        <span class="icon-colored-star star-3"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                        <span class="subtitle" v-if="variantTitle!==''">{{variantTitle}}</span>
                    </span>
                </h2>
                <div class="max-highlights" :class="{ 'small-max-highlights' : maxHighlights.length===2}" v-if="maxHighlights.length > 0">
                    <div class="max-highlight" v-for="maxHighlight in maxHighlights">
                        <div class="max-highlight-value">
                            <span :class="{'icon-stopwatch': maxHighlight.withStopwatch, 'bg-circle': !maxHighlight.withStopwatch}"></span>
                            <span class="value">{{ maxHighlight.value }}</span>
                        </div>
                        <div class="max-highlight-title">
                            {{ maxHighlight.unit }}
                        </div>
                        <div class="max-highlight-details">
                            {{ maxHighlight.text }}
                        </div>
                    </div>
                </div>
                <div class="best-seller-highlights">
                    <div class="best-seller-highlight">
                        {{ $t("reduced_shipping_delay") }}
                    </div>
                    <div class="best-seller-highlight">
                        {{ $t("advantageous_arguments") }}
                    </div>
                    <div class="best-seller-highlight">
                        {{ $t("preset_equipment_selection") }}
                    </div>
                </div>
                <div class="white-container" v-if="standardEquipmentsParts.length>0 || standardEquipments.label">
                    <h3 class="box-title">{{ $t("best_seller_standard_equipments") }}</h3>
                    <div class="equipment-list-parts" v-if="standardEquipmentsParts.length>0">
                        <equipment-list
                            v-for="(standardEquipments,index) in standardEquipmentsParts"
                            :key="index"
                            :products="standardEquipments"
                            class="part"
                            :list-type="'flex'"
                        />
                    </div>
                    <template v-if="standardEquipments.label" >
                      <br/>
                      <div class="equipment-list-parts" v-if="standardEquipments.label" v-html="standardEquipments.label" />
                    </template>

                    <span class="icon-colored-star star-4"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                    <span class="icon-colored-star star-5"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                    <span class="icon-colored-star star-6"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                </div>
                <div class="white-containers" :class="{'no-plus':(standardEquipmentsParts.length==0 && !standardEquipments.label)}">
                    <div class="white-container"  v-if="optionEquipmentsParts.length>0 || optionEquipments.label">
                        <h3 class="box-title">{{ $t("additional_optional_equipments") }}</h3>

                        <equipment-list v-if="optionEquipmentsParts.length>0" :products="optionEquipmentsParts" :list-type="'flex'"/>
                        <template v-if="optionEquipments.label" >
                          <div class="equipment-list-parts" v-html="optionEquipments.label"></div>
                        </template>
                        <template v-if="adviceBestSeller">
                            <span class="icon-colored-star star-7"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                            <span class="icon-colored-star star-8"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                            <span class="icon-colored-star star-9"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                        </template>
                    </div>
                    <div class="white-container" v-if="optionAccessories.length > 0">
                        <h3 class="box-title">{{ $t("additional_optional_accessories") }}</h3>

                        <equipment-list :products="optionAccessories" v-if="optionAccessories.length>0" :list-type="'flex'"/>
<!--                        <div class="optionals-accessories-container">
                            <div class="optionals-accessories-slider-controls-container">
                                <hooper
                                    ref="optionals-accessories-slider"
                                    :itemsToShow="2"
                                    :centerMode="true"
                                    :wheelControl="false"
                                    @slide="slideChanged"
                                >
                                    <slide v-for="(optionAccessory, index) in optionAccessories" :key="optionAccessory.identifier">
                                        <card-accessory-light :datas="optionAccessory" :class="['is-slide-item', {'is-slide-item-active': index === currentSlide}]" />
                                    </slide>
                                </hooper>
                                <div class="optionals-accessories-slider-controls">
                                    <button class="icon-arrow-left control previous" :class="{hidden: currentSlide === 0}" @click.prevent="slidePrev"></button>
                                    <button class="icon-arrow-right control next" :class="{hidden: currentSlide === (optionAccessories.length-1)}" @click.prevent="slideNext"></button>
                                </div>
                            </div>
                        </div>-->
                    </div>
                </div>
                <div class="white-container black-version" v-if="adviceBestSeller">
                    <h3 class="box-title">{{ $t("notes") }}</h3>
                    <div class="advice" v-html="adviceBestSeller"></div>
                    <span class="icon-colored-star star-10"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                </div>
            </div>
        </main>
    </transition>
</template>

<script>
import { Hooper, Slide } from 'hooper';

import productService from '@/services/serli/product'

import EquipmentList from "@/components/Equipment/EquipmentList.vue"
import CardAccessoryLight from "@/components/Card/CardAccessoryLight.vue"

import '@/../node_modules/hooper/dist/hooper.css';
import {mapGetters, mapState} from "vuex";

export default {
    name: 'MachineBestSellerView',
    components: {
        Hooper,
        Slide,
        EquipmentList,
        CardAccessoryLight
    },
    props: {
        productDatas: {
            type: Object,
            required: true
        },
        bestSellerFinitions: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            displayContent: false,
            productFinitionDatas: null,
            standardEquipmentsParts: [],
            optionEquipmentsParts: [],
            optionEquipments: [],
            standardEquipments: [],
            optionAccessories: [],
            currentSlide: 0,
            currentIdentifier:null,
            variantTitle:'',
        }
    },
    computed: {
      ...mapState({
        unitType: state => state.settings.unitType,
      }),
      ...mapGetters({
        localeKebabFormat: 'settings/localeKebabFormat'
      }),
      currentBestSeller() {
      //  console.log(this.bestSellerFinitions)
        if(this.productDatas.identifier===this.currentIdentifier) {
          let reference = this.productDatas.attributes.find((x) => x.code==='reference_best_seller')
          if(reference) this.variantTitle=reference.value.label
          else this.variantTitle= this.productDatas.name
          return this.productDatas;
        } else {
          let variant = this.productDatas.variants.find((product)=>product.identifier===this.currentIdentifier)
          let reference = null
          reference = variant.attributes.find((x) => x.code==='reference_best_seller')
          if(reference) this.variantTitle=reference.value.label
          else this.variantTitle= this.productDatas.name+" - "+variant.name
          return variant;
        }
      },
      adviceBestSeller() {
        var advice=this.currentBestSeller.attributes.find(x => x.code==='advice_best_seller')
        if(advice) return advice.value.label; else return false;

      },
      maxHighlights(){
          let maxHighlights = [];

          var delivery=this.currentBestSeller.attributes.find(x => x.code==='delivery_times_for_standard_best_seller')

          if(delivery)
              maxHighlights.push({
                  value: parseInt(delivery.value[this.unitType].amount),
                  unit: delivery.value[this.unitType].unit === 'week' ? this.$t('max_weeks') : "?",
                  text: this.$t('for_the_standard_version_bestseller'),
                  withStopwatch: true
              })

          var delivery_options=this.currentBestSeller.attributes.find(x => x.code==='delivery_times_for_best_seller_version_with_options_and_attachments')
          if(delivery_options)
              maxHighlights.push({
                  value: parseInt(delivery_options.value[this.unitType].amount),
                  unit: delivery_options.value[this.unitType].unit === 'week' ? this.$t('max_weeks') : "?",
                  text: this.$t('with_additional_equipments_and_accessories'),
                  withStopwatch: true
              })
          var max_unit=this.currentBestSeller.attributes.find(x => x.code==='max_units_orders_for_standard_best_seller')
          if(max_unit)
              maxHighlights.push({
                  value: parseInt(max_unit.value.label),
                  unit: this.$t('max_units'),
                  text: this.$t('any_version'),
                  withStopwatch: false
              })
          return maxHighlights;
      }
    },
    created(){
        if(this.bestSellerFinitions[0]) this.loadBestSellerDatas(this.bestSellerFinitions[0].identifier);
        this.$bus.$on('refreshProductFinitionDatas', (identifier) => this.loadBestSellerDatas(identifier));
    },
    methods: {
        loadBestSellerDatas(identifier) {
          this.resetValues()
            this.displayContent = false;
            this.currentIdentifier=identifier
            this.getStandardEquipments()
            .then(this.getOptionEquipments())
            .then(this.getOptionAccessories())
            .finally(this.displayContent = true)
        },
        async getStandardEquipments() {
           let promisesArray = [];
           let equipements=[];

            //var standardEquipments=(this.currentBestSeller.options.equipments_standard_best_seller) ? this.currentBestSeller.options.equipments_standard_best_seller : null;
              if(this.currentBestSeller.options.equipments_standard_best_seller) {
                this.currentBestSeller.options.equipments_standard_best_seller.forEach(finitionStandardProduct => {
                  promisesArray.push(productService.show(finitionStandardProduct.code, {
                    productType: 'attachments',
                    brand: this.$store.state.settings.brand,
                    full: false,
                    size: 999,
                    page: 1,
                    locale: this.localeKebabFormat,
                  }));
                })

                let standardEquipmentsList = await Promise.all(promisesArray).then(responses => {
                  let productsDatas = [];
                  for (const response of responses)
                    productsDatas.push(response.data.data)
                  return productsDatas;
                });
                this.standardEquipmentsParts = this.$_.chunk(standardEquipmentsList, _.ceil(standardEquipmentsList.length / 2));
              }

              if (this.currentBestSeller.attributes.find((attribute)=>attribute.code==="equipments_standard_best_seller")) {
                equipements = this.currentBestSeller.attributes.find((attribute)=>attribute.code==="equipments_standard_best_seller")
                this.standardEquipments = equipements.value
              }
        },

        async getOptionEquipments() {
          let promisesArray = [];
          let optionEquipments=[];

          if(this.currentBestSeller.options.best_seller_options) {
            this.currentBestSeller.options.best_seller_options.forEach(bestSellerProduct => {
              promisesArray.push(productService.show(bestSellerProduct.code, {
                productType: 'attachments',
                brand: this.$store.state.settings.brand,
                full: false,
                size: 999,
                page: 1,
                locale: this.localeKebabFormat,
              }));
            })

            let options = await Promise.all(promisesArray).then(responses => {
              let productsDatas = [];
              for (const response of responses)
                productsDatas.push(response.data.data)
              return productsDatas;
            });

            this.optionEquipmentsParts = options
          }


          if(this.currentBestSeller.attributes.find((attribute)=>attribute.code==="best_seller_options")){
            optionEquipments = this.currentBestSeller.attributes.find((attribute)=>attribute.code==="best_seller_options")
            this.optionEquipments = optionEquipments.value
          }

        },

      async getOptionAccessories() {
        let promisesArray = [];
        if(this.currentBestSeller.attachments.attachments_machines_best_seller) {
          this.currentBestSeller.attachments.attachments_machines_best_seller.forEach(optionsProduct => {
            promisesArray.push(productService.show(optionsProduct.code, {
              productType: 'attachments',
              brand: this.$store.state.settings.brand,
              full: false,
              size: 999,
              page: 1,
              locale: this.localeKebabFormat,
            }));
          })

          let optionAccessories = await Promise.all(promisesArray).then(responses => {
            let productsDatas = [];
            for (let i = 0; i < responses.length; i++) {
              let productData = responses[i].data.data
              if (productData.identifier !== this.currentBestSeller.attachments.attachments_machines_best_seller[i].code) {
                productData.variantTitle = this.currentBestSeller.attachments.attachments_machines_best_seller[i].label
              }
              productsDatas.push(productData)
            }
            /*for (const response of responses) {
              let productData = response.data.data
              if (productData.variants.length) {
                let matchVariant = false
                for (const variant of productData.variants) {
                  if (variant.attachments && variant.attachments.attachment_association) {
                    let item = variant.attachments.attachment_association.find(attachment => attachment.code === this.currentIdentifier)
                    if (item) {
                      productData.variantTitle = variant.name
                      if (!productsDatas.find(product => (product.identifier === productData.identifier && product.variantTitle === productData.variantTitle))) {
                        productsDatas.push(productData)
                        matchVariant = true
                        break;
                      }
                    }
                  }
                }
                if (!matchVariant) productsDatas.push(productData)
              } else productsDatas.push(productData)
            }*/
            return productsDatas;
          });
          this.optionAccessories = optionAccessories
        }
      },

      resetValues() {
        this.variantTitle=''
        this.standardEquipmentsParts= []
        this.optionEquipmentsParts= []
        this.optionEquipments= []
        this.standardEquipments= []
        this.optionAccessories= []
      },

        slidePrev() {
            this.$refs['optionals-accessories-slider'].slidePrev();
        },
        slideNext() {
            this.$refs['optionals-accessories-slider'].slideNext();
        },
        slideChanged(payload) {
            this.currentSlide = payload.currentSlide;
        },
    }
}
</script>

<style lang="scss">
    #machine-sheet-best-seller {
        min-height: 100vh;
        padding: 65px 0 100px 0;
        background-image: radial-gradient(circle at 50% 47%, $brand-red, #690808);
        text-align: center;


        .wrapper {
            max-width: 1280px;
            margin: 0 auto;

            [class*=" star-"] {
                @media #{$mq_phone} {
                    display: none;
                }
            }

            .main-title-container {
                .main-title {
                    position: relative;
                    font-size: 50px;
                    line-height: 50px;
                    font-weight: 900;
                    color: $white;

                    @media #{$mq_phone} {
                        font-size: 30px;
                        line-height: 30px;
                    }

                    .star-1 {
                        position: absolute;
                        top: 30px;
                        right: -50px;
                        font-size: 40px;
                    }

                    .star-2 {
                        position: absolute;
                        top: 40px;
                        right: -100px;
                        font-size: 30px;
                    }

                    .star-3 {
                        position: absolute;
                        top: 70px;
                        right: -70px;
                        font-size: 26px;
                    }

                  .subtitle{
                    margin-top:10px;
                    display:block;
                  }
                }
            }

            .max-highlights {
                margin-top: 70px;
                display: flex;
                justify-content: center;
                color: $white;

              &.small-max-highlights {
                max-width:80%;
                margin-right:auto;
                margin-left:auto;
              }

                @media #{$mq_phone} {
                    display: block;
                }

                .max-highlight {
                    flex: 1 1 33.33%;
                    padding: 0 20px;

                    @media #{$mq_phone} {
                        margin: 60px 0 20px 0;
                    }

                    &-value {
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 53px;
                        height: 100px;
                        font-weight: 900;

                        [class^="icon-"], [class*=" icon-"] {
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            font-size: 100px;
                        }

                        .bg-circle {
                            display: inline-block;
                            margin: 0 auto;
                            width: 100px;
                            height: 100px;
                            border: 6px solid $white;
                            border-radius: 100px;
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                        }
                    }

                    &-title {
                        margin-top: 20px;
                        font-size: 18px;
                        font-weight: 900;
                    }

                    &-details {
                        margin-top: 12px;
                        font-size: 15px;
                        line-height: 19px;
                        color: $white;
                    }
                }
            }

            .best-seller-highlights {
                margin-top: 50px;
                margin-bottom: 35px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: $white;

                @media #{$mq_phone} {
                    display: block;
                }

                .best-seller-highlight {
                    flex: 1 1 auto;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0 20px;
                    font-size: 15px;
                    line-height: 19px;
                    color: $white;

                    @media #{$mq_phone} {
                        margin: 15px 0;
                        justify-content: flex-start;
                    }

                    &:before {
                        @include icomoon;
                        content: "\e902";
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        height: 25px;
                        width: 25px;
                        margin-right: 12px;
                        background-color: $white;
                        color: $brand-red;
                        font-size: 9px;
                        border-radius: 25px;
                    }
                }
            }

            .white-container {
                position: relative;
                padding: 30px;
                background-color: $white;
                border-radius: 20px;
                text-align: left;



                &.black-version {
                    color: $white;
                    background-color: rgba(0, 0, 0, 0.2);
                }

                .equipment-list-parts {
                    display: flex;
                  ul {

                      padding-left: 20px;
                      list-style-type: disc;

                  }

                    @media #{$mq_phone} {
                        display: block;
                    }

                    .part {
                        flex: 1 1 auto;
                    }
                }

                .box-title {
                    font-size: 30px;
                    font-weight: 900;
                    line-height: 34px;

                    @media #{$mq_phone} {
                        font-size: 22px;
                        line-height: 26px;
                    }
                }

                .advice {
                    margin-top: 20px;
                    line-height: 18px;
                }

                .star-4 {
                    position: absolute;
                    top: 119px;
                    right: -70px;
                    font-size: 20px;
                }

                .star-5 {
                    position: absolute;
                    top: 207px;
                    right: -80px;
                    font-size: 60px;
                }

                .star-6 {
                    position: absolute;
                    top: 332px;
                    right: -95px;
                    font-size: 32px;
                }

                .star-7 {
                    position: absolute;
                    top: 119px;
                    left: -70px;
                    font-size: 20px;
                }

                .star-8 {
                    position: absolute;
                    top: 207px;
                    left: -80px;
                    font-size: 60px;
                }

                .star-9 {
                    position: absolute;
                    top: 332px;
                    left: -95px;
                    font-size: 32px;
                }

                .star-10 {
                    position: absolute;
                    top: 192px;
                    left: -20px;
                    font-size: 32px;
                }
            }

            .white-containers {
                display: flex;
                margin: 20px 0;

                @media #{$mq_phone} {
                    display: block;
                }


                .white-container {
                    flex: 1 1 400px;

                    &{
                        margin-right: 20px;

                        @media #{$mq_phone} {
                            margin-right: 0;
                            margin-bottom: 20px;
                        }

                        &:before {
                            @include icomoon;
                            content: '\e909';
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            position: absolute;
                          z-index:9999;
                            top: -35px;
                            left: 35px;
                            width: 45px;
                            height: 45px;
                            font-size: 14px;
                            color: $white;
                            background-color: #c10f0f;
                            border-radius: 45px;

                            @media #{$mq_phone} {
                                left: 50%;
                                margin-left: -17px;
                            }
                        }


                    }
                 //&:last-child {
                 //  &:before {
                 //    @include icomoon;
                 //    content: '\e909';
                 //    display: inline-flex;
                 //    align-items: center;
                 //    justify-content: center;
                 //    position: absolute;
                 //    top: -35px;
                 //    right: -100px;
                 //    z-index: 2;
                 //    width: 45px;
                 //    height: 45px;
                 //    font-size: 14px;
                 //    color: $white;
                 //    background-color: #c10f0f;
                 //    border-radius: 45px;

                 //    @media #{$mq_phone} {
                 //      top: auto;
                 //      bottom: -35px;
                 //      left: 50%;
                 //      margin-left: -17px;
                 //    }
                 //  }
                 //}

                }

              &.no-plus {
                .white-container:before {display:none}
              }
              .optionals-accessories-container {
                overflow-x: hidden;
                overflow-y: auto;
                max-width:550px;

                .optionals-accessories-slider-controls-container {
                  position: relative;

                  .hooper-list {
                    margin: 35px 0;

                    .hooper-slide {
                      padding: 0 30px;
                      height: auto;
                      text-align: center;

                      @media #{$mq_phone} {
                        padding: 0 10px;
                        max-width:100%;
                      }

                      .is-slide-item {
                        opacity: 0.5;
                        transition: opacity 0.5s ease;

                        &.is-slide-item-active {
                          opacity: 1;
                        }

                        .title {
                          @media #{$mq_phone} {
                            font-size: 12px;
                          }
                        }
                      }
                    }
                  }

                  .optionals-accessories-slider-controls {
                    .control {
                      display: inline-flex;
                      align-items: center;
                      justify-content: center;
                      width: 36px;
                      height: 36px;
                      color: $white;
                      font-size: 9px;
                      border-radius: 50%;
                      background-color: $black;
                      cursor: pointer;
                      transition: transform 0.3s ease;

                      &:hover:not(.hidden) {
                        transform: scale(1.15);
                      }

                      &.previous {
                        position: absolute;
                        top: 50%;
                        margin-top: -30px;
                        left: 20px;
                      }

                      &.next {
                        position: absolute;
                        top: 50%;
                        margin-top: -30px;
                        right: 20px;
                      }

                      &.hidden {
                        display: none;
                      }
                    }
                  }
                }
              }
            }
        }
    }
</style>